export const isFile = input => {
	return Object.prototype.toString.call(input) === '[object File]'
}

export const sleep = (time, unit) => new Promise((resolve) => {
	const ms = unit === 's' ? time * 1000 : unit === 'm' ? time * 60 * 1000 : unit === 'h' ? time * 60 * 60 * 1000 : time;
	setTimeout(() => resolve(), ms);
});

export const injectScript = (URL, id, callback) => {
	if (document.getElementById(id)) return callback();

	const tag = "script",
		documentTag = document,
		script = documentTag.createElement(tag),
		scriptTag = documentTag.getElementsByTagName(tag)[0];

	script.id = id;
	script.src = "//" + URL;

	if (callback) script.addEventListener("load", () => callback(), false);
	scriptTag.parentNode.insertBefore(script, scriptTag);
}